(function() {
    'use strict';

    angular
        .module('app.eventos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/eventos',
                config: {
                    templateUrl: 'app/eventos/list.html',
                    controller: 'eventos.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-evento/:id?',
                config: {
                    templateUrl: 'app/eventos/edit.html',
                    controller: 'eventos.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            },
            {
                url: '/ver-inscritos-evento/:eventoId/:categoriaId?',
                config: {
                    templateUrl: 'app/eventos/verInscritos.html',
                    controller: 'eventos.VerInscritos',
                    controllerAs: 'vm',
                    title: 'VerInscritos'
                }
            }
        ];
    }
})();
